import DefaultPageLayout from "@/layouts/DefaultPageLayout";
import { Divider, Skeleton } from "@nextui-org/react";
import clsx from "clsx";
function ManagementPackageLoading() {
  return <DefaultPageLayout data-sentry-element="DefaultPageLayout" data-sentry-component="ManagementPackageLoading" data-sentry-source-file="index.tsx">
            <div className="flex flex-col gap-5">
                <div className="flex flex-col gap-3">
                    <Skeleton className="w-20 h-5 bg-default/10 before:opacity-20 rounded" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
                    <div className="flex flex-col gap-2.5">
                        <div className="flex items-center justify-between gap-20">
                            <Skeleton className="flex-1 h-5 bg-default/10 before:opacity-20 rounded" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
                            <Skeleton className="size-5 bg-default/10 before:opacity-20 rounded" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <Skeleton className="w-full h-10 rounded-2xl bg-default/10 before:opacity-20" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
                    <Skeleton className="w-full h-40 rounded-2xl bg-default/10 before:opacity-20" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
                    <Skeleton className="w-full h-40 rounded-2xl bg-default/10 before:opacity-20" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
                    <Skeleton className="w-full h-40 rounded-2xl bg-default/10 before:opacity-20" data-sentry-element="Skeleton" data-sentry-source-file="index.tsx" />
                </div>
                <div className="flex items-center justify-center gap-1">
                    {Array(5).fill(4).map((_, i) => <Skeleton className="size-9 bg-default/10 before:opacity-20 rounded-full" key={i} />)}
                </div>
            </div>
        </DefaultPageLayout>;
}
export default ManagementPackageLoading;